export default "__VITE_ASSET__40ee5d06__"